<template>
  <div class="error-banner">
    <span>{{ message }}</span>
    <button @click="$emit('close')" class="close-button">&times;</button>
  </div>
</template>

<script>
export default {
  name: 'ErrorBanner',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  emits: ['close'],
}
</script>

<style scoped>
.error-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #721c24; /* Dark red text */
  background-color: #f8d7da; /* Light red background */
  border-color: #f5c6cb; /* Reddish border */
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1;
  color: #721c24;
  cursor: pointer;
  padding: 0 0 0 1rem;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.close-button:hover {
  opacity: 1;
}
</style>
